import React from 'react';
import './ui.css';

/**
 * SectionLabel
 * The small green uppercase tag shown above section headings.
 * e.g.  "Everything you need"
 */
function SectionLabel({ children }) {
  return (
    <p className="section-label">{children}</p>
  );
}

export default SectionLabel;